{
  "platform": {
    "integrations": {
      "nav": "Integrations",
      "zoho": {
        "title": "Zoho CRM",
        "subtitle": "The connection that copies Book a Demo leads into the owner's Zoho CRM organisation. Tokens and secrets stay on the server and are never shown here.",
        "connection": "Connection",
        "status": "Status",
        "connected": "Connected",
        "notConnected": "Not connected",
        "orgId": "Organisation ID",
        "orgVerified": "Organisation verified",
        "environment": "Environment",
        "dataCentre": "Data centre",
        "apiDomain": "API domain",
        "scopes": "Scopes",
        "noScopes": "None",
        "connectedAt": "Connected on",
        "connectedBy": "Connected by",
        "lastVerified": "Last verified",
        "connect": "Connect Zoho CRM",
        "connectHint": "You sign in to Zoho to authorise the connection, then return to this page.",
        "cannotStart": "Zoho CRM cannot be connected yet",
        "reconnect": "Connect again",
        "reconnectHint": "Connecting again keeps the current connection until the new one is verified.",
        "unsafeAddress": "The server returned a sign-in address that is not Zoho's sign-in page for the Saudi data centre, so it was not opened.",
        "disconnect": "Disconnect",
        "disconnectTitle": "Disconnect Zoho CRM?",
        "disconnectBody": "Fidelen stops sending leads to Zoho until it is connected again. No lead is deleted, in Fidelen or in Zoho.",
        "disconnected": "Zoho CRM is disconnected.",
        "resultConnected": "Zoho CRM is connected.",
        "resultRefused": "Zoho CRM was not connected",
        "sync": "Lead sync",
        "syncEnabled": "Sync",
        "syncOn": "On",
        "syncOff": "Off",
        "syncReadOnly": "Read-only: the sync is not switched on or off from this console.",
        "ownerPolicy": "Lead owner policy",
        "ownerVerified": "Lead owner verified",
        "fieldMapValid": "Field mapping valid",
        "problems": "Problems",
        "noProblems": "No problems reported.",
        "problem": {
          "accounts_url_invalid": "The Zoho accounts URL on the server is missing or is not a Zoho accounts address (DevOps)",
          "api_domain_invalid": "The Zoho API domain on the server is missing or is not a Zoho API address (DevOps)",
          "data_centre_mismatch": "The Zoho accounts URL and API domain on the server belong to different data centres (DevOps)",
          "environment_invalid": "The Zoho environment on the server is neither production nor sandbox (DevOps)",
          "api_domain_environment_mismatch": "The Zoho API domain on the server does not match the configured environment (DevOps)",
          "client_id_missing": "The Zoho client ID is not set on the server (DevOps)",
          "client_secret_missing": "The Zoho client secret is not set on the server (DevOps)",
          "org_id_invalid": "The Zoho organisation ID on the server is missing or invalid (DevOps)",
          "field_map_invalid": "The Zoho field mapping on the server is missing or invalid (DevOps)",
          "lead_source_inconsistent": "The Lead Source value and its field mapping on the server must be set together, or neither (DevOps)",
          "redirect_uri_invalid": "The Zoho redirect URI on the server is missing or is not Fidelen's callback address (DevOps)",
          "owner_not_decided": "The lead-owner policy has not been chosen (the owner decides; DevOps sets it on the server)",
          "owner_id_invalid": "The Zoho lead owner's user ID on the server is missing or invalid (DevOps)",
          "owner_policy_conflict": "New leads go to the connecting user, but a lead owner ID is also set on the server: one of the two must go (DevOps)",
          "owner_unverified": "The configured Zoho lead owner is not verified as an active user, so nothing is written: check that user in Zoho, then connect again",
          "environment_guard": "Blocked: a test environment may not write to the production Zoho organisation, nor production to a sandbox (DevOps)",
          "not_connected": "Zoho CRM is not connected: connect it on this page",
          "connection_mismatch": "The connection is for another organisation, environment or data centre than the server's settings: connect again, or correct the settings (DevOps)",
          "authorisation_revoked": "Zoho refused the saved authorisation (revoked or expired): connect again on this page",
          "unknown": "A problem this console does not recognise"
        },
        "refusal": {
          "state_invalid": "The connection request expired, was already used or was not recognised: start again",
          "session_mismatch": "Another operator is signed in here than the one who started the connection: start again from your own session",
          "operator_not_permitted": "The operator who started the connection is no longer active or may not manage integrations",
          "consent_denied": "Access was not granted in Zoho",
          "accounts_server_mismatch": "Zoho answered from another accounts server than the one configured (DevOps)",
          "not_configured": "This server is not set up to connect Zoho: see the problems on this page (DevOps)",
          "code_missing": "Zoho returned no authorisation code: start again",
          "code_exchange_failed": "Zoho did not exchange the authorisation code: start again, and if it repeats, check the client settings (DevOps)",
          "api_domain_mismatch": "Zoho authorised another API domain than the one configured; nothing was kept (DevOps)",
          "org_check_failed": "Fidelen could not read the Zoho organisation to check it; nothing was kept: try again",
          "org_mismatch": "The Zoho account authorised is not the configured organisation; nothing was kept: sign in to Zoho with the owner's organisation"
        }
      }
    }
  }
}
